module.exports = __webpack_public_path__ + "img/logo2.8d30f9b8.png";